import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { BrandLogo } from '@/components/brand-logo'

export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="auth-shell">
      <a href="#auth-content" className="skip-link">
        Saltar al formulario
      </a>
      <aside className="auth-story" aria-label="St. George English School">
        <Link to="/" aria-label="Volver al inicio">
          <BrandLogo inverse className="w-56" />
        </Link>
        <div className="auth-story-copy">
          <p className="brand-eyebrow">ENSEÑAR · APRENDER · CRECER</p>
          <p className="auth-story-title">
            Cada día,
            <br />
            una nueva
            <br />
            <span>oportunidad.</span>
          </p>
          <p>
            Un espacio para acompañar a quienes aprenden y a quienes hacen
            posible su aprendizaje.
          </p>
        </div>
        <div className="auth-emblem" aria-hidden="true">
          <img src="/brand/symbol-on-green.svg" alt="" width={67} height={48} />
        </div>
        <p className="auth-story-foot">St. George · English School</p>
      </aside>
      <div className="auth-content-wrap">
        <header className="auth-mobile-brand">
          <Link to="/" aria-label="Volver al inicio">
            <BrandLogo />
          </Link>
        </header>
        <main id="auth-content" className="auth-content" tabIndex={-1}>
          {children}
        </main>
        <footer className="auth-footer">
          <Link to="/">Volver al inicio</Link>
          <span>© {new Date().getFullYear()} St. George</span>
        </footer>
      </div>
    </div>
  )
}
